interface BannerProps {
	logoPaths: string[]
	reverse: boolean
}

const ScrollingBanner = ({ logoPaths, reverse }: BannerProps) => {
	const logos = logoPaths
	return (
		<div className="overflow-hidden">
			<div
				className={`flex lg:gap-12 gap-3 md:gap-6 ${
					reverse ? "animate-loop-scroll-reverse" : "animate-loop-scroll"
				}`}
				style={{ width: 'max-content' }}
			>
				{[...logos, ...logos, ...logos, ...logos].map((logo, index) => (
					<div 
						key={index}
						className="bg-[#1c1c1c] xl:w-56 xl:h-56 md:w-48 md:h-48 w-28 h-28 sm:w-36 sm:h-36 xl:p-12 md:p-10 p-6 sm:p-8 flex-shrink-0"
					>
						<img
							draggable="false"
							loading="lazy"
							decoding="async"
							width={128}
							height={128}
							src={logo}
							className="w-full h-full object-contain"
							alt={`Client logo ${(index % logos.length) + 1}`}
						/>
					</div>
				))}
			</div>
		</div>
	)
}

export default ScrollingBanner
